"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_buttons_1 = require("@hotelplan/components.common.buttons");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const AutocompleteContext_1 = require("./AutocompleteContext");
const AutocompleteMoreButtonWrap = styled_components_1.default.div(({ theme }) => (0, util_theme_sxc_1.sx2CssTheme)(theme, {
    pb: [4, 2],
    textAlign: 'right',
}));
const LoadMoreButton = (0, styled_components_1.default)(components_common_buttons_1.Button).attrs({
    variant: 'linkBtn',
    'data-id': `load-more`,
})(({ theme, theme: { colors } }) => {
    var _a;
    return (0, util_theme_sxc_1.sx2CssThemeFn)(Object.assign({ color: colors.primary, marginLeft: 'auto' }, (((_a = theme.autocomplete) === null || _a === void 0 ? void 0 : _a.loadMoreButton) || {})));
});
const AutocompleteMoreButton = props => {
    const [t] = (0, next_i18next_1.useTranslation)('common');
    const ctx = (0, AutocompleteContext_1.useAutocompleteContext)();
    function onClick(e) {
        var _a;
        (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        ctx.nextPage();
    }
    if (props === null || props === void 0 ? void 0 : props.withoutWrapper) {
        return (react_1.default.createElement(LoadMoreButton, Object.assign({}, props, { onClick: onClick }), t('common:load.more')));
    }
    return (react_1.default.createElement(AutocompleteMoreButtonWrap, null,
        react_1.default.createElement(LoadMoreButton, Object.assign({}, props, { onClick: onClick }), t('common:load.more'))));
};
exports.default = AutocompleteMoreButton;
//# sourceMappingURL=AutocompleteMoreButton.js.map